import CategoryList from '../../components/category-list/category-list.component.';

const Home = () => {

  return (
    <div>
      <CategoryList/>
    </div>
  );
};

export default Home;
